import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  descriptionTextField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
      width: '100%',
    },
    '& .MuiInputBase-multiline': {
      width: '100%',
    },
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  characterCounter: {},
  listItem: {
    marginTop: '16px'
  },
  divider: {
    margin: '16px 0px'
  },
  sectionTitle: {
    fontWeight: foundations.typography.fontWeight.medium
  },
  dialogContent: {
    overflow: 'visible',
  },
  folderDropdownContainer: {
    marginTop: '8px'
  },
  confirmDialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  },
});
